import { BigmlFieldDTO, IBigmlFieldDTO } from "./BigmlFields.DTO";
import { Nilable } from "@shared/utils";

export interface IBigmlDatasetsDTO {
    project_id: Nilable<number>;
    dataset_resource: Nilable<string>;
    datasets: Nilable<IBigmlDatasetDTO[]>;
}

export class BigmlDatasetsDTO {
    public projectId = 0;
    public datasetResource = "";
    public datasets: Nilable<BigmlDatasetDTO[]> = null;

    constructor(json: Nilable<Partial<IBigmlDatasetsDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlDatasetsDTO>) {
        if (json.project_id != null) {
            this.projectId = json.project_id;
        }
        if (json.dataset_resource != null) {
            this.datasetResource = json.dataset_resource;
        }
        if (json.datasets != null) {
            this.datasets = json.datasets.map(dataset => new BigmlDatasetDTO(dataset));
        }
    }

    public toJSON(): IBigmlDatasetsDTO {
        return {
            project_id: this.projectId,
            dataset_resource: this.datasetResource,
            datasets: this.datasets?.map(dataset => dataset.toJSON()) ?? null
        };
    }
}


export interface IProgressTrackerDTO {
    id: number;
    state: string;
    predict_attempts: number;
}

export class ProgressTrackerDTO {
    id: number;
    state: string;
    predictAttempts = 0;

    constructor(json: Nilable<IProgressTrackerDTO> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: IProgressTrackerDTO) {
        this.id = json.id;
        this.state = json.state;
        this.predictAttempts = json.predict_attempts;
    }

    public toJSON(): IProgressTrackerDTO {
        return {
            id: this.id,
            state: this.state,
            predict_attempts: this.predictAttempts
        };
    }
}

export interface IBigmlDatasetDTO {
    id: number;
    name: string;
    type: string;
    resource: string;
    status: string;
    state: Nilable<string>;
    progress: Nilable<IProgressTrackerDTO[]>;
    project_id: number;
    datasets_id: number;
    datasets_name: string;
    gender: string;
    age_range: string;
    datasets_resource: string;
    fields: IBigmlFieldDTO[];
}

export class BigmlDatasetDTO {
    public id = 0;
    public name = "";
    public type = "";
    public resource = "";
    public status = "";
    public progress: Nilable<ProgressTrackerDTO[]> = null;
    public state = "";
    public projectId = 0;
    public datasetsId = 0; // datasetsId?
    public datasetsName = "";
    public gender = ""; // ?
    public ageRange = ""; // ?
    public datasetsResource = "";
    public fields: BigmlFieldDTO[] = []; // no se si hay endpoint que sea dataset_id + fields?

    constructor(json: Nilable<Partial<IBigmlDatasetDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlDatasetDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.name = json.name;
        }
        if (json.type != null) {
            this.type = json.type;
        }
        if (json.resource != null) {
            this.resource = json.resource;
        }
        if (json.status != null) {
            this.status = json.status;
        }
        if (json.state != null) {
            this.state = json.state;
        }
        if (json.progress != null) {
            this.progress = json.progress.map(
                progress_entry => new ProgressTrackerDTO(progress_entry));
        }
        if (json.project_id != null) {
            this.projectId = json.project_id;
        }
        if (json.datasets_id != null) {
            this.datasetsId = json.datasets_id;
        }
        if (json.datasets_name != null) {
            this.datasetsName = json.datasets_name;
        }
        if (json.gender != null) {
            this.gender = json.gender;
        }
        if (json.age_range != null) {
            this.ageRange = json.age_range;
        }
        if (json.datasets_resource != null) {
            this.datasetsResource = json.datasets_resource;
        }
        if (json.fields != null) {
            this.fields = json.fields.map(field => new BigmlFieldDTO(field));
        }
    }

    public toJSON(): IBigmlDatasetDTO {
        return {
            id: this.id,
            name: this.name,
            type: this.type,
            resource: this.resource,
            status: this.status,
            state: this.state,
            // no interesa devolver el progress en toJSON()
            progress: this.progress? this.progress.map(progress => progress.toJSON()) : null,
            project_id: this.projectId,
            datasets_id: this.datasetsId,
            datasets_name: this.datasetsName,
            gender: this.gender,
            age_range: this.ageRange,
            datasets_resource: this.datasetsResource,
            fields: this.fields?.map(field => field.toJSON())
        };
    }
}
